export default __webpack_public_path__ + "static/fabric-profile-about-fabric-view-a3119a9ae45b8d51754fac750381f5e2.png";